import * as React from 'react';
import { styled } from '@linaria/react';

interface Props {
  twinkleSpeed: number;
  isToggled: boolean;
}

function Ball({ twinkleSpeed, isToggled }: Props) {
  return (
    <Wrapper
      data-is-toggled={isToggled}
      style={{ '--twinkle-speed': twinkleSpeed + 'ms' }}
    >
      <BallWrapper>
        <BallSocket />
        {isToggled && <BallElem />}
      </BallWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const BallWrapper = styled.div`
  position: relative;
`;

const BallSocket = styled.div`
  --size: 64px;
  position: relative;
  width: var(--size);
  height: var(--size);
  border: 2px solid var(--color-gray-300);
  border-radius: 45%;
  background: url('/images/partial-keyframes/transparent-white-16x16-10p.png')
    repeat;
`;

const BallElem = styled.div`
  position: absolute;
  inset: 0;
  background: hsl(50deg 100% 50%);
  border-radius: 45%;

  @keyframes twinkle {
    from {
      opacity: 0.25;
    }
    to {
      opacity: 0.75;
    }
  }

  /* HACK: When I put this in the conditional block below, the "twinkle" keyframe doesn't get picked up correctly by Linaria. So I need to set it by default and then unset it conditionally: */
  animation:
    twinkle var(--twinkle-speed) infinite alternate,
    fadeFromTransparent 2000ms;

  ${Wrapper}[data-is-toggled='false'] & {
    animation: none;
  }
`;

export default Ball;
